module.exports = __webpack_public_path__ + "img/banner-29.27e93915.jpg";